<template>
  <div>
<!--    <terms-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter"-->
<!--                       :paginationData="filterSet.page"></terms-filter-link>-->
    <terms-list-link :listLayout="listLayout" :termsData="List" :paginationData="filterSet.page"
                     :termsType="termsType"></terms-list-link>
    <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"
                     :listLength="List.length"></pagination-link>
  </div>
</template>

<script>
import TermsListLink from "@/components/terms/TermsListLink";
import TermsFilterLink from "@/components/terms/TermsFilterLink";
import PaginationLink from "@/components/terms/PaginationLink";
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import alertMixins from "@/mixins/alertMixins";
import termsUtil from "./termsUtil";
import EventBus from "@/utils/event-bus";

const {filterConfig} = termsUtil;

export default {
  name: "TermsListComponent",
  mixins: [alertMixins,filterMixins, listMixins, termsUtil],
  components: {TermsFilterLink, TermsListLink, PaginationLink},
  inject: [],
  provide() {
    return {
      setPage: this.setPage,
      setFilter: this.setFilter,
      setTermsListData:this.setData,
    }
  },

  props: {
    termsType: '',
  },
  data() {
    return {
      listLayout: '',
      listApiParamSet: {},
      filterLayout: '',
      paginationLayout: '',
      paginationType: '',
      getFunc: '',

      filterDate: '',
      filterSort: false,
      language: [],
    }
  },
  created() {
    this.setFilterConfig(filterConfig)
    this.setParserType('url', this.$route.fullPath);
    this.initConfig()
  },
  mounted() {
    this.getList(true)
    EventBus.$on('termsListDeleteAfterFunc', this.termsListDeleteAfterFunc);
  },
  beforeDestroy() {
    EventBus.$off('termsListDeleteAfterFunc')
  },
  destroyed() {
  },
  computed: {},
  methods: {
    initConfig() {
      let termsConfig = this.returnTermsConfig(this.termsType);
      this.listLayout = termsConfig.listLayout;
      this.filterLayout = termsConfig.filterLayout;
      this.paginationLayout = termsConfig.paginationLayout;
      this.listApiParamSet = termsConfig.listApiParamSet;
      this.paginationType = termsConfig.paginationType;
      this.getFunc = termsConfig.getFunc;

      termsConfig.pageRow && termsConfig.pageRow != 10 ? this.filterSet.page.size = termsConfig.pageRow : '';

      let params = JSON.parse(JSON.stringify(this.listApiParamSet));
      params.ty = this.termsType;
      params.cid = [2];

      let listOptions = {
        url: this.$api.$config[this.getFunc],
        defaultParams: params,
      }
      this.initList('api', listOptions)
    },

    setData(key, value) {
      this[key] = value;
    },
    termsListDeleteAfterFunc(key, value) {
      let boardIndex = this.List.findIndex(board => board[key] === value);
      if (boardIndex < 0) {
        return false;
      }
      this.List.splice(boardIndex, 1);
      this.filterSet.page.total = this.filterSet.page.total - 1;
      if (this.paginationType === 'lazyload' && (this.List.length < this.filterSet.page.total)) {
        let params = JSON.parse(JSON.stringify(this.listApiParamSet));
        params.page = this.filterSet.page.page * this.filterSet.page.size;
        params.sp = 1;
        this.$api.$config[this.getFunc](params).then(res => res.Data.Result).then(res => {
          if (res.Info.type === 1 && res.List.length > 0) {
            this.List.push(res.List[0]);
          }
        })
      }
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>
